import { i18n } from "@/i18n/i18n-config";
export const config = {
  //120000ms
  StatisticLoadTimmer: 120000,
  SibarItems: [
    {
      key: 0,
      name: "Dashboard",
      title: i18n.global.t("i18nCommon.Dashboard"),
      router: "/dashboard",
      icon: "icon-24 icon-dashboard",
    },
    //product
    {
      key: 2,
      name: "Product",
      title: i18n.global.t("i18nCommon.Product"),
      router: "/product",
      icon: "icon-24 icon-product",
    },
    //category
    {
      key: 3,
      name: "Category",
      title: i18n.global.t("i18nCommon.Category"),
      router: "/category",
      icon: "icon-24 icon-category",
    },
    //supplier
    {
      key: 4,
      name: "Supplier",
      title: i18n.global.t("i18nCommon.Supplier"),
      router: "/supplier",
      icon: "icon-24 icon-supplier",
    },
    //order
    {
      key: 5,
      name: "Order",
      title: i18n.global.t("i18nCommon.Order"),
      router: "/order",
      icon: "icon-24 icon-order",
    },
    //customer
    {
      key: 6,
      name: "Customer",
      title: i18n.global.t("i18nCommon.Customer"),
      router: "/customer",
      icon: "icon-24 icon-customer",
    },
    //shipper
    {
      key: 7,
      name: "Shipper",
      title: i18n.global.t("i18nCommon.Shipper"),
      router: "/shipper",
      icon: "icon-24 icon-shipper",
    },
    //saleEmployee
    {
      key: 8,
      name: "SaleEmployee",
      title: i18n.global.t("i18nCommon.SaleEmployee"),
      router: "/sale-employee",
      icon: "icon-24 icon-sale-employee",
    },
    //help support
    {
      key: 9,
      name: "HelpSupport",
      title: i18n.global.t("i18nCommon.HelpSupport"),
      router: "/help-support",
      icon: "icon-24 icon-help-support",
    },
    //setting
    {
      key: 10,
      name: "Setting",
      title: i18n.global.t("i18nCommon.Setting"),
      router: "/setting",
      icon: "icon-24 icon-setting",
    },
    //about me
    {
      key: 11,
      name: "AboutMe",
      title: i18n.global.t("i18nCommon.AboutMe"),
      router: "/about-me",
      icon: "icon-24 icon-about-me",
    },
  ],
  MenuCategories: [
    {
      id: 1,
      display: i18n.global.t("i18nCommon.Product"),
      router: "/create-product",
    },
    {
      id: 2,
      display: i18n.global.t("i18nCommon.Category"),
      router: "/create-category",
    },
    {
      id: 3,
      display: i18n.global.t("i18nCommon.Supplier"),
      router: "/create-supplier",
    },
    {
      id: 4,
      display: i18n.global.t("i18nCommon.Order"),
      router: "/create-order",
    },
    {
      id: 5,
      display: i18n.global.t("i18nCommon.Customer"),
      router: "/create-customer",
    },
    {
      id: 6,
      display: i18n.global.t("i18nCommon.Shipper"),
      router: "/create-shipper",
    },
    {
      id: 7,
      display: i18n.global.t("i18nCommon.SaleEmployee"),
      router: "/create-employee",
    },
    {
      id: 8,
      display: i18n.global.t("i18nCommon.AddItem"),
      router: "/create-item",
    },
  ],
  Languages: [
    {
      id: 1,
      display: i18n.global.t("i18nCommon.Vietnamese"),
      lang: "vi",
    },
    {
      id: 2,
      display: i18n.global.t("i18nCommon.English"),
      lang: "en",
    },
  ],
  MenuUser: [
    {
      id: 1,
      display: i18n.global.t("i18nCommon.Language"),
    },
    {
      id: 2,
      display: i18n.global.t("i18nCommon.Logout"),
    },
  ],
  StatusInfos: [
    { id: 'ACTIVE', status: i18n.global.t("i18nCommon.Active") },
    { id: 'INACTIVE', status: i18n.global.t("i18nCommon.Inactive") },
  ],

  OrderStatusInfos: [
    { id: 'PLACED', status: 'PLACED' },
    { id: 'PROCESSING', status: 'PROCESSING' },
    { id: 'SHIPPED', status: 'SHIPPED' },
    { id: 'DELIVERED', status: 'DELIVERED' },
    { id: 'CANCELLED', status: 'CANCELLED' }
  ],

  MaxRowItems: 8,
};
